export const BASE_URL = 'https://3e8dfe5.online-server.cloud/elpi/public/api';
